<template>
	<div ref="rowWrapper" class="row">
		<div :class="[columnClasses.default]">
			<transition name="reveal-from-left">
				<figure 
					v-if="data.image" 
					ref="animationTarget" 
					:class="['swipe-in-target', 'image', { reveal: reveal }]">
					<img 
						v-bind:src="data.image.src"
						v-bind:srcset="data.image.srcset" 
						v-bind:alt="data.image.alt" 
						@load="setMediaColumnHeight" />
					<figcaption v-if="data.caption" v-html="data.caption"></figcaption>
				</figure>
			</transition>
		</div>
	</div>
</template>

<script>
import BaseMediaBlock from './BaseMediaBlock'
export default {
	extends: BaseMediaBlock
}
</script>